var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Lib"},[_c('div',{staticClass:"PageZg"},[_vm._v(_vm._s(_vm.title))]),_c('CardsSwitcher',{attrs:{"show":_vm.show},on:{"switchTo":_vm.switchTo}}),_c('CardPreviews',{attrs:{"cards":_vm.cards(_vm.show)}}),_c('div',{staticClass:"Fraza"},[_vm._v("Вместе каждый может больше!")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }